import { useEffect, useState } from "react";
import GtmFormularfeldId from "../../../../../gtm/types/GtmFormularfeldId";
import StringUtil from "../../../../../app/util/StringUtil";
import useInputSubmitValidator, { generateValidatorId } from "../../../../../form/input/useInputSubmitValidator";
import TextInputField from "../../../../cmp/input/TextInputField";
import useWizardFormCtx from "../../ctx-provider/useWizardFormCtx";
import FormBo from "../FormBo";
import FormHundBo from "../FormHundBo";
import { HundeNameValidator } from "./HundeNameValidator";

export const exportName = (bo: FormHundBo) => StringUtil.trim(bo.name);

type Param = {
    index: number // start with 1
}

const VALIDATOR_ID = generateValidatorId("IhrTier-HundeName");

const HundeName: React.FC<Param> = ({ index }) => {
    // *** Formulardaten werden geladen
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const actuHund = FormBo.selectHund(wizardFormBo.ihrTier, index);
    const [name, setName] = useState(actuHund.name);

    // *** Validator
    const { validationState, fireFieldValidation } = useInputSubmitValidator(VALIDATOR_ID, new HundeNameValidator(name), index);

    const updateValidationState = (value?: string) => {
        fireFieldValidation(new HundeNameValidator(value));
    }

    // ****************************
    // init
    // ****************************
    useEffect(() => {
        if (!StringUtil.isBlank(name)) {
            updateValidationState(name);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ****************************
    // events
    // ****************************
    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        updateValidationState(value);

        actuHund.name = value;
        fireWizardFormBo(wizardFormBo);
    }

    // Formulardaten werden aktualisiert
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setName(event.target.value);
    }

    return (
        <TextInputField id="hundeName" idGtm={GtmFormularfeldId.hundeName} idGtmIndex={index}
            label="Hundename"
            value={name}
            onBlur={handleOnBlur}
            onChange={handleOnChange}
            preventSubmitOnEnter={false}
            maxLength={HundeNameValidator.MAX_LENGTH}
            required={true}
            error={validationState.error}
            helperText={validationState.message}
        />
    );
}

export default HundeName;